export enum MarketTypes {
    outright = "OutRight"
}